import Vue from 'vue';
import App from './App.vue';
import vuetify from "./plugins/vuetify";
import router from './router';
import store from './store';
import viewOnlyMixin from './mixins/view-only';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "@/styles/main.css";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import "@/styles/toast.css";

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');

      const markIfWaiting = () => {
        if (registration.waiting) {
          store.commit('app/SET_UPDATE_AVAILABLE', registration.waiting);
        }
      };

      // Covers the case where a new version finished installing while
      // this tab was open but hasn't been surfaced yet (e.g. a deploy
      // landed between page loads and the browser already found it).
      markIfWaiting();

      // Fires when a new service worker is found for the first time in
      // this tab's lifetime — the actual "deploy happened" signal.
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // "installed" + an existing controller means this is an
            // update, not the very first install on this device.
            store.commit('app/SET_UPDATE_AVAILABLE', newWorker);
          }
        });
      });

      // The browser only checks for a new SW automatically on
      // navigation. This is a long-lived SPA — poll periodically so a
      // deploy is noticed even if the user never reloads on their own.
      setInterval(() => registration.update().catch(() => {}), 30 * 60 * 1000);
    } catch (err) {
      console.error('Service worker registration failed:', err);
    }
  });
}

(async () => {
  try {
    await store.dispatch('auth/restoreSession');
  } catch (e) {
    // not logged in → ignore
  }

  Vue.mixin(viewOnlyMixin);

  Vue.use(Toast, {
    position: POSITION.TOP_RIGHT,
    timeout: 1500,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    transition: "pl-toast-fade",
    maxToasts: 4,
    newestOnTop: true,
    icon: true,
    hideProgressBar: false,
  });

  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
})();

